// extracted by mini-css-extract-plugin
module.exports = {"cronometro":"Cronometro_cronometro__25zc5","relogioWrapper":"Cronometro_relogioWrapper__1G5nL","titulo":"Cronometro_titulo__2yuHg"};